const PI = Math.PI;
const EARTH_RADIUS = 6371008.8;
const RAD = Math.PI / 180.0;

// const Ea = 6371008.8; //   赤道半径
const Ea = 6378137; //   赤道半径
const Eb = 6356725; //   极半径

function getPointRangeByRadius(lon, lat, radius) {
    let latitude = lat;
    let longitude = lon;

    let degree = (24901 * 1609) / 360.0;
    let raidusMile = radius;

    let dpmLat = 1 / degree;
    let radiusLat = dpmLat * raidusMile;
    let minLat = latitude - radiusLat;
    let maxLat = latitude + radiusLat;

    let mpdLng = degree * Math.cos(latitude * (PI / 180));
    let dpmLng = 1 / mpdLng;
    let radiusLng = dpmLng * raidusMile;
    let minLng = longitude - radiusLng;
    let maxLng = longitude + radiusLng;
    return [minLat, minLng, maxLat, maxLng];
}

function getlatLon(LAT, LON, distance, angle) {
    const dx = distance * Math.sin(angle * Math.PI / 180.0);
    const dy = distance * Math.cos(angle * Math.PI / 180.0);
    const ec = Eb + (Ea - Eb) * (90.0 - LAT) / 90.0;
    const ed = ec * Math.cos(LAT * Math.PI / 180);
    const newLon = (dx / ed + LON * Math.PI / 180.0) * 180.0 / Math.PI;
    const newLat = (dy / ec + LAT * Math.PI / 180.0) * 180.0 / Math.PI;
    return [newLon, newLat];
}

function getPolygonCirclePoints(lat, lon, radius) {
    const point = [lon, lat];
    const points = [];
    for (let index = 0; index < 96; index++) {
        let latLonData = getlatLon(
            lat,
            lon,
            radius,
            ((index + 1) * 360) / 96
        );
        points.push(latLonData);
    }
    return points;
}

export { getPointRangeByRadius, getPolygonCirclePoints };


// WEBPACK FOOTER //
// ./src/assets/js/lonLatRadiusUtil.js